import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  border: 1px solid #ccc;
`;

export const TableHeader = styled.thead``;

export const TableHeaderRow = styled.tr``;

export const TableHeaderCell = styled.th`
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableCell = styled.td`
  padding: 8px;
  vertical-align: top;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
`;

export const TableCellBottom = styled(TableCell)`
  border-bottom: 1px solid #ccc;
`;

export const FieldLabel = styled.strong``;

export const FieldValue = styled.div``;

export const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  background-color: #f2f2f2;
  text-align: left;

  letter-spacing: 0.03em;
  font-family: Arial, Helvetica, 'Times New Roman', serif; // fixing the custom font (Roboto) caused issues in generated PDF
`;

export const Td = styled.td<{ $width?: string }>`
  border: 1px solid #ddd;
  padding: 8px;
  width: ${({ $width }) => $width && $width};
  text-align: left;
`;

export const TotalTr = styled.tr`
  > td {
    font-weight: bold;
    letter-spacing: 0.03em; // fixing the letter spacing in generated PDF
    font-family: Arial, Helvetica, 'Times New Roman', serif; // fixing the custom font (Roboto) caused issues in generated PDF
  }
`;
